<div class="scm-card" data-testid="settings-confirm-modal-card">
  <div class="scm-header">
    <p class="scm-title" data-testid="settings-confirm-modal-title">{{ config.title }}</p>
    <button type="button" class="scm-close-btn" data-testid="settings-confirm-modal-close-btn" (click)="cancel()" aria-label="Close">
      <i class="fa-solid fa-xmark"></i>
    </button>
  </div>

  <p class="scm-message">{{ config.message }}</p>

  <div class="scm-actions">
    <button
      type="button"
      class="cs-action-btn"
      [class.cs-action-btn--danger]="config.confirmVariant === 'danger'"
      [class.cs-action-btn--primary]="config.confirmVariant === 'primary'"
      (click)="confirm()"
    >
      {{ config.confirmText }}
    </button>
    <button type="button" class="cs-action-btn cs-action-btn--floating" (click)="cancel()">
      {{ config.cancelText }}
    </button>
  </div>
</div>
